<template>
    <v-card tile outlined :loading="loading" :disabled="loading">
        <v-card-actions class="mb-0 pt-0">
            <v-radio-group v-model="selectedSearchType" row>
                <v-radio
                        label="Tradenames"
                        value="names"
                >
                </v-radio>
                <v-radio
                        label="Contact Names"
                        value="contacts"
                >
                </v-radio>
                <v-radio
                        label="Licenses"
                        value="licences"
                >
                </v-radio>
            </v-radio-group>
            <v-spacer></v-spacer>
            <slot name="actions"></slot>
        </v-card-actions>
        <v-card-actions class="mb-0 pb-0">
            <v-autocomplete
                    v-model="selectedCustomer"
                    label="Search"
                    :items="items"
                    :search-input.sync="searchValue"
                    no-filter
                    item-value="customer_id"
                    @change="selectedCustomer ? $emit('selected', selectedCustomer) : null"
                    dense
                    solo
                    filled
                    outlined
                    class="elevation-0"
            >
                <template v-slot:item="{item}">
                    <v-list-item-content>
                        <v-list-item-title v-if="selectedSearchType === 'licenses'">{{item.license}}</v-list-item-title>
                        <v-list-item-title v-else-if="selectedSearchType === 'contacts'">{{item.name}}</v-list-item-title>
                        <v-list-item-title v-else>{{item.name}}</v-list-item-title>
                        <v-list-item-subtitle v-if="selectedSearchType !== 'names' && item.customer">{{item.customer.names[0].name}}</v-list-item-subtitle>
                    </v-list-item-content>
                </template>
                <template v-slot:selection="{item}">
                    <v-chip label v-if="selectedSearchType !== 'names' && item.customer">{{item.customer.names[0].name}}</v-chip>
                    <v-chip label v-else>{{item.name}}</v-chip>
                </template>
            </v-autocomplete>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "CustomerSearch",
        data: () => ({
           selectedSearchType: 'names',
            selectedCustomer: null,
            searchValue: null,
            items: [],
            searchTimeout: null,
            loading: false,
        }),
        watch:{
            selectedSearchType(v){
                this.loadDataSets()
            },
            searchValue(v){
                    clearTimeout(this.searchTimeout)
                    this.searchTimeout = setTimeout(() => {
                        this.search();
                    }, 1000)
            }
        },
        mounted(){
            this.loadDataSets()
        },
        methods:{
            async loadDataSets(){
                this.loading = true;
                this.$store.dispatch('entities/deleteAll')
                await this.$store.$db().model('customers').api().fetch({with: 'contract.contractType,environment.environmentType'});
                await this.$store.$db().model('names').api().fetch();
                switch(this.selectedSearchType){
                    case 'licenses':
                        await this.$store.$db().model('licenses').api().fetch();
                        break;
                    case 'contacts':
                        await this.$store.$db().model('contacts').api().fetch();
                        break;
                    default:
                        break;
                }
                this.loading = false;
            },
            search(){

                if(this.searchValue && this.searchValue !== ''){
                    this.items = [];
                    if(this.selectedSearchType !== 'name'){
                        this.items = this.$store.$db().model(this.selectedSearchType).query().with('customer.names', query => {
                            query.where('name_type_id', 1)
                        }).search(this.searchValue).get()
                        return;
                    }else{
                        this.items = this.$store.$db().model(this.selectedSearchType).query().search(this.searchValue).get();
                        return;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
